// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createHook,
	createStore,
	createContainer,
	createActionsHook,
	type Action,
} from '@atlassian/react-sweet-state';
import type { AsyncExportIssuesCommonInput } from '../../common/types.tsx';

type Actions = {
	addExportInProgress: (attr: {
		exportName: string;
		flagId: string;
		commonInput: AsyncExportIssuesCommonInput;
	}) => Action<Store>;
	removeExportInProgress: (exportName: string) => Action<Store>;
};

const actions: Actions = {
	addExportInProgress:
		({ exportName, flagId, commonInput }) =>
		({ setState, getState }) => {
			const state = getState();
			setState({
				exportsInProgress: new Map([
					...state.exportsInProgress,
					[exportName, { flagId, commonInput }],
				]),
			});
		},
	removeExportInProgress:
		(exportName) =>
		({ setState, getState }) => {
			const state = getState();
			const exportsInProgress = new Map(state.exportsInProgress);
			exportsInProgress.delete(exportName);
			setState({ exportsInProgress });
		},
};

type Store = {
	exportsInProgress: Map<
		string,
		{
			flagId: string;
			commonInput: AsyncExportIssuesCommonInput;
		}
	>;
};

const store = createStore<Store, Actions>({
	initialState: {
		exportsInProgress: new Map(),
	},
	actions,
});

export const ExportIssuesState = createContainer<Store, Actions, {}>(store, {});

export const useExportIssuesState = createHook(store);
export const useExportIssuesStateActions = createActionsHook(store);
